/* eslint-disable */
if (!window.Salty_GlobalTrackingTrigger) {
  console.log(
    "SS Salty_GlobalTrackingTrigger::",
    window.Salty_GlobalTrackingTrigger,
  );
  window.Salty_GlobalTrackingTrigger = true;
  console.log(
    "SS after Salty_GlobalTrackingTrigger::",
    window.Salty_GlobalTrackingTrigger,
  );

  (function () {
    function ga4Tracking(category, action, label) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "Convert_Test_Tracking",
        category,
        action,
        label,
      });
    }

    function convertGoal(id) {
      window._conv_q = window._conv_q || [];
      _conv_q.push(["triggerConversion", id]);
    }

    function delegateEvent(el, evt, sel, handler) {
      el.addEventListener(evt, function (event) {
        let t = event.target;
        while (t && t !== this) {
          if (t.matches(sel)) {
            event.matchedSelector = t;
            handler.call(t, event);
          }
          t = t.parentNode;
        }
      });
    }

    function waitUntil(predicate, time = 10000) {
      return new Promise((resolve) => {
        let int = setInterval(() => {
          if (predicate()) {
            resolve(predicate());
            clearInterval(int);
            int = null;
          }
        }, 500);
        setTimeout(() => {
          if (int !== null) {
            clearInterval(int);
            console.log("condition false");
          }
        }, time);
      });
    }

    function waitForElement(selector) {
      return new Promise((resolve) => {
        const element = document.querySelector(selector);

        if (element) {
          resolve(element);
          return;
        }

        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            const nodes = Array.from(mutation.addedNodes);
            // eslint-disable-next-line no-restricted-syntax
            for (const node of nodes) {
              if (node.matches && node.matches(selector)) {
                observer.disconnect();
                resolve(node);
                return;
              }
            }
          });
        });

        observer.observe(document.documentElement, {
          childList: true,
          subtree: true,
        });
      });
    }

    function trackScrollDepth(cat, action, label) {
      const { pathname } = window.location;
      const isMenPage = pathname.includes("/mens") ? "Men" : "";
      const fired = {
        25: {
          hasFired: false,
          category: cat,
          action: action + " 25% " + isMenPage,
          label: label,
        },
        50: {
          hasFired: false,
          category: cat,
          action: action + " 50% " + isMenPage,
          label: label,
        },
        75: {
          hasFired: false,
          category: cat,
          action: action + " 75% " + isMenPage,
          label: label,
        },
        100: {
          hasFired: false,
          category: cat,
          action: action + " 100% " + isMenPage,
          label: label,
        },
      };

      const onScroll = () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const docHeight = document.documentElement.scrollHeight;
        const winHeight = window.innerHeight;

        const scrollable = docHeight - winHeight;
        if (scrollable <= 0) return;

        const scrollPercent = Math.floor((scrollTop / scrollable) * 100);

        [25, 50, 75].forEach((point) => {
          if (scrollPercent >= point && !fired[point].hasFired) {
            fired[point].hasFired = true;
            convertGoal(fired[point].convertId);
            ga4Tracking(
              fired[point].category,
              fired[point].action,
              fired[point].label,
            );
          }
        });

        if (scrollTop + winHeight >= docHeight - 2 && !fired[100].hasFired) {
          fired[100].hasFired = true;
          convertGoal(fired[100].convertId);
          ga4Tracking(fired[100].category, fired[100].action, fired[100].label);
        }
      };

      window.addEventListener("scroll", onScroll, { passive: true });
    }

    const detectThemeSlide = () => {
      const carouselEl = document.querySelector(
        ".product-slideshow.flickity-enabled",
      );
      const flkty = window.Flickity && window.Flickity.data(carouselEl);

      if (flkty) {
        flkty.on("change", (index) => {
          ga4Tracking("PDP", "PDP: Image Interaction", index);
        });
      }
    };

    setTimeout(() => {
      const { pathname } = window.location;

      if (pathname === "/" || pathname === "/pages/mens-accessories") {
        trackScrollDepth("Homepage", "Homepage - Scroll", "Homepage - Scroll");
      }

      if (
        pathname.includes("/collections/") &&
        !pathname.endsWith("/collections/")
      ) {
        trackScrollDepth("PLP", "PLP - Scroll", "PLP - Scroll");
      }

      if (pathname.includes("/products/") && !pathname.endsWith("/products/")) {
        trackScrollDepth("PDP", "PDP - Scroll", "PDP - Scroll");
      }

      if (pathname !== "/products/" && pathname.includes("/products/")) {
        detectThemeSlide();
      }

      if (pathname === "/pages/gifting-page") {
        trackScrollDepth(
          "GIFT landing page",
          "GIFT landing page - Scroll",
          "GIFT landing page - Scroll",
        );
      }

      delegateEvent(document, "mousedown", "body", ({ target }) => {
        if (pathname === "/" || pathname === "/pages/mens-accessories") {
          const isMenPage = pathname.includes("/mens") ? " Men" : "";

          if (window.innerWidth < 768) {
            const isCategoryRoundel = target.closest("a.circular-link");
            if (isCategoryRoundel) {
              const categoryName = isCategoryRoundel
                .querySelector(".circular-box-txt-wrapper")
                .textContent.trim();
              ga4Tracking(
                "Homepage",
                `Homepage - Category Roundels Interaction${isMenPage}_m`,
                categoryName,
              );
            }

            const stickyNavItem = target.closest(".sticky-item-link");

            if (stickyNavItem) {
              const navItem =
                stickyNavItem
                  .querySelector(".sticky-small-txt")
                  ?.textContent?.trim() || stickyNavItem.textContent.trim();
              ga4Tracking(
                "Homepage",
                `Homepage - Bottom Nav interaction_M${isMenPage}`,
                navItem,
              );
            }
          }

          if (
            target.closest(
              '.hero__slide-link:not([href="/pages/deal-of-the-day-men"]):not([href="/pages/deal-of-the-week-women"])',
            )
          ) {
            const bannerName = target.closest("a").getAttribute("href");
            ga4Tracking(
              "Homepage",
              `Homepage - Banner Intereraction${isMenPage}`,
              bannerName,
            );
          }

          const bannerContainer = target.closest(
            'div[id*="slick-slide"][data-entity-position]',
          );

          if (bannerContainer) {
            const bannerPosition =
              bannerContainer.getAttribute("data-entity-position") || "";
            const bannerName =
              bannerContainer.querySelector("a")?.getAttribute("href") || "";

            ga4Tracking(
              "Homepage",
              `Homepage - Sub Banner Position Interaction${isMenPage}`,
              bannerPosition,
            );
            ga4Tracking(
              "Homepage",
              `Homepage - Sub Banner Intereraction${isMenPage}`,
              bannerName,
            );
          }

          if (
            target.closest(
              'a[href="/pages/deal-of-the-week-women"], a[href="/pages/deal-of-the-day-men"]',
            )
          ) {
            const bannerUrl = target.closest("a").getAttribute("href");
            ga4Tracking(
              "Homepage",
              `Homepage - Deal of the week Interaction${isMenPage}`,
              bannerUrl,
            );
          }

          const isAddToCartButton = target.closest("button[data-add-to-cart]");

          if (isAddToCartButton) {
            const productCard = isAddToCartButton.closest(".new-product-card");
            const productName =
              productCard
                ?.querySelector("h3.new-product-card__title")
                ?.textContent?.trim() || "";

            ga4Tracking(
              "Homepage",
              `Homepage - Add to Cart Click${isMenPage}`,
              productName,
            );
          }

          if (target.closest(".new-featured-collection")) {
            const collectionContainer = target.closest(
              ".new-featured-collection",
            );
            const isCategoryBannerInteracted = target.closest(
              ".new-featured-collection__header.new-featured-collection__header--with-banner",
            );
            const isCategoryTileInteracted =
              target.closest(".new-product-card");
            const categoryName = collectionContainer
              .querySelector(
                ".new-featured-collection__header.new-featured-collection__header--with-banner img",
              )
              .getAttribute("alt")
              .trim();
            if (isCategoryBannerInteracted) {
              ga4Tracking(
                "Homepage",
                `Homepage - Category Banner Interaction${isMenPage}`,
                categoryName,
              );
            } else if (isCategoryTileInteracted) {
              const productCard = target.closest(".new-product-card");
              const productName =
                productCard
                  ?.querySelector("h3.new-product-card__title")
                  ?.textContent?.trim() || "";
              ga4Tracking(
                "Homepage",
                `Homepage - Category Product Tile Interaction${isMenPage}`,
                productName,
              );
            } else if (
              target.closest(".new-featured-collection__view-all-link")
            ) {
              ga4Tracking(
                "Homepage",
                `Homepage - Category View All Interaction${isMenPage}`,
                categoryName,
              );
            }
          }

          if (target.closest('ul[aria-label="Collections tabs"] li')) {
            const tab = target
              .closest('ul[aria-label="Collections tabs"] li')
              .querySelector("span.tab-label");
            const tabName = tab.textContent.trim();
            ga4Tracking(
              "Homepage",
              `Homepage - Feeling Lost Category Interaction${isMenPage}`,
              tabName,
            );
          }

          if (
            target.closest(
              ".new-collection-tabs-grid__tab-panel.is-active .new-product-card",
            )
          ) {
            const productContainer = target.closest(".new-product-card");
            const productName = productContainer
              .querySelector("h3 title")
              .textContent.trim();
            ga4Tracking(
              "Homepage",
              `Homepage - Feeling Lost Product Interaction${isMenPage}`,
              productName,
            );
          }

          if (target.closest('ul[aria-label="Collections tabs"] li')) {
            const tab = target
              .closest('ul[aria-label="Collections tabs"] li')
              .querySelector("span.tab-label");
            const tabName = tab.textContent.trim();
            ga4Tracking(
              "Homepage",
              `Homepage - Collections Tab Interaction${isMenPage}`,
              tabName,
            );
          }

          if (
            target.closest(
              ".new-collection-tabs-grid__tab-panel.is-active .new-product-card",
            )
          ) {
            const productContainer = target.closest(".new-product-card");
            const productName = productContainer
              .querySelector("h3 title")
              .textContent.trim();
            ga4Tracking(
              "Homepage",
              `Homepage - Collection Tab Product Interaction${isMenPage}`,
              productName,
            );
          }

          const lbcCard = target.closest(".lbcCard");
          const lbcProduct = target.closest("a.lbcCard__product");

          if (lbcCard || lbcProduct) {
            ga4Tracking(
              "Homepage",
              `Homepage - Loved by Creators Interaction${isMenPage}`,
              pathname,
            );

            const product =
              lbcProduct || lbcCard?.querySelector("a.lbcCard__product");
            const productName = product
              ?.querySelector(".lbcCard__product-title")
              ?.textContent?.trim();

            if (productName) {
              ga4Tracking(
                "Homepage",
                `Homepage - Loved by Creators Product Interaction${isMenPage}`,
                productName,
              );
            }
          }

          if (target.closest(".price-drop-card")) {
            const productCard = target
              .closest(".price-drop-card")
              .getAttribute("href");
            ga4Tracking(
              "Homepage",
              `Homepage - Price drop corner Interaction${isMenPage}`,
              productCard,
            );
          }

          if (target.closest(".custom-testimonial-section")) {
            ga4Tracking(
              "Homepage",
              `Homepage - Reviews Interaction${isMenPage}`,
              "Interaction",
            );
          }

          if (target.closest(".custom-faq-item")) {
            const faqQuestion = target
              .closest(".custom-faq-item")
              .querySelector("button span")
              .textContent.trim();
            ga4Tracking(
              "Homepage",
              `Homepage - FAQ Interaction${isMenPage}`,
              faqQuestion,
            );
          }

          if (target.closest("button.fi-readmore")) {
            ga4Tracking(
              "Homepage",
              `Homepage - Read More (Salty)${isMenPage}`,
              "Interaction",
            );
          }

          const socialLink = target.closest(".smpl-img-link");

          if (socialLink) {
            console.log("Social link clicked:", socialLink.href);
            ga4Tracking(
              "Homepage",
              `Homepage - Social Visits${isMenPage}`,
              "Click",
            );
          }

          // Homepage - Deal of the day product Interaction
        }

        if (
          pathname.includes("/collections/") &&
          !pathname.endsWith("/collections/")
        ) {
          if (
            target.closest('button[class*="drawer-open-collection-filters"]')
          ) {
            ga4Tracking(
              "PLP",
              "PLP : Clicks on Filter_M",
              "PLP : Clicks on Filter_M",
            );
          }

          if (target.closest("#SortBy")) {
            ga4Tracking("PLP", "PLP : Clicks on Sort", "PLP : Clicks on Sort");
          }

          if (target.closest("#SortBy option")) {
            const sortOption = target
              .closest("#SortBy option")
              .textContent.trim();
            ga4Tracking("PLP", "PLP : Clicks on Sort", sortOption);
          }

          if (target.closest("form.filter-form button")) {
            const appliedFilter = target
              .closest("form.filter-form button")
              .textContent.trim();
            ga4Tracking(
              "PLP",
              "PLP : Interaction with Filter Option",
              appliedFilter,
            );
          }

          if (target.closest("form.filter-form li")) {
            const appliedFilter = target
              .closest("form.filter-form li")
              .textContent.trim();
            ga4Tracking(
              "PLP",
              "PLP : Interaction with Filter Value",
              appliedFilter,
            );
          }

          if (target.closest("#FilterDrawer .drawer__close-button")) {
            ga4Tracking("PLP", "PLP : Close the filter", pathname);
          }

          const removedFilter = target.closest("li.tag.tag--remove");
          if (removedFilter) {
            const filterName =
              removedFilter.querySelector("a")?.textContent?.trim() || "";
            ga4Tracking("PLP", "PLP : Click on remove filter", filterName);
          }

          if (target.matches("#SortBy")) {
            const sortOption =
              target.options[target.selectedIndex]?.textContent?.trim() || "";
            ga4Tracking(
              "PLP",
              "PLP : Interaction with Sort Option",
              sortOption,
            );
            console.log("Sort option fired:", sortOption);
          }

          if (target.closest(".new-product-card__media img")) {
            const productName = target
              .closest(".new-product-card__media img")
              .getAttribute("alt");
            ga4Tracking("PLP", "PLP : Clicks on Product image", productName);
          }

          if (target.closest(".new-product-card__bottom")) {
            const productCard = target.closest(".new-product-card");
            const productName =
              productCard
                ?.querySelector("h3.new-product-card__title")
                ?.textContent?.trim() || "";
            ga4Tracking(
              "PLP",
              "PLP : Clicks on Product description",
              productName,
            );
          }

          if (target.closest(".new-product-card .new-product-card__wishlist")) {
            const productCard = target.closest(".new-product-card");
            const productName =
              productCard
                ?.querySelector("h3.new-product-card__title")
                ?.textContent?.trim() || "";
            ga4Tracking("PLP", "PLP : Clicks on Wishlist", productName);
          }

          if (target.closest("span[data-add-to-cart-text]")) {
            const productCard = target.closest(".new-product-card");
            const productName =
              productCard
                ?.querySelector("h3.new-product-card__title")
                ?.textContent?.trim() || "";
            ga4Tracking("PLP", "PLP : ATC Clicks", productName);
          }

          const faqButton = target.closest(".question_container button");
          if (faqButton) {
            const faqQuestion =
              faqButton
                .querySelector("span:not(.custom-faq-plus-icon)")
                ?.textContent?.trim() || "";
            ga4Tracking("PLP", "PLP : Interaction with FAQ", faqQuestion);
          }

          const reviewTile = target.closest(
            ".jdgm-widget, .jdgm-preview-badge, .jdgm-prev-badge",
          );

          if (reviewTile) {
            ga4Tracking(
              "PLP",
              "PLP : Interaction with Review on product tile",
              "PLP : Interaction with Review on product tile",
            );
          }

          if (target.closest(".alpha.custom-tag")) {
            const productItem = target.closest(
              '.new-featured-collection-grid__item, [data-helium-name="product-item"]',
            );
            const productName =
              productItem
                ?.querySelector("h3.new-product-card__title")
                ?.textContent?.trim() || "";
            ga4Tracking("PLP", "PLP : Clicks on tag", productName);
          }

          if (
            target.closest("#MobileFilterCategory li") &&
            window.innerWidth < 768
          ) {
            const productName = target
              .closest("#MobileFilterCategory li")
              .textContent.trim();
            ga4Tracking(
              "PLP",
              `PLP : In-page Filter Interaction_M`,
              productName,
            );
          }
        }

        if (
          pathname.includes("/products/") &&
          !pathname.endsWith("/products/")
        ) {
          if (target.closest(".product__thumb-item")) {
            const thumbIndex = target
              .closest(".product__thumb-item")
              .getAttribute("data-index");
            ga4Tracking("PDP", "PDP: Thumbnails Interaction", thumbIndex + 1);
          }

          if (target.closest("#view_more_btn")) {
            ga4Tracking(
              "PDP",
              "PDP: View Offer Interaction",
              "PDP: View Offer Interaction",
            );
          }

          if (target.closest("button.copy_btn")) {
            const offerName = target
              .closest(".fst_coupon_wrapper.offer_wrapper")
              .querySelector(".coupon_txt_new")
              .textContent.trim();
            ga4Tracking("PDP", "PDP: Copy Coupon Interaction", offerName);
          }

          const qtyBtn = target.closest(
            ".js-qty__adjust--minus, .js-qty__adjust--plus",
          );

          if (qtyBtn) {
            const qtyInput = qtyBtn
              .closest(".js-qty__wrapper")
              ?.querySelector('input[name="quantity"], .js-qty__num');
            const currentValue = parseInt(qtyInput?.value || "1", 10);
            const nextValue = qtyBtn.classList.contains("js-qty__adjust--plus")
              ? currentValue + 1
              : Math.max(1, currentValue - 1);
            ga4Tracking("PDP", "PDP: Quantity Interaction", String(nextValue));
          }

          const pdpReviewStar = target.closest(
            ".jdgm-preview-badge, .jdgm-prev-badge, .jdgm-prev-badge__stars",
          );
          if (pdpReviewStar) {
            ga4Tracking(
              "PDP",
              "Reviews Star Interaction on 1st fold",
              "Reviews Star Interaction on 1st fold",
            );
          }

          if (target.closest(".all_offers_body button.code-copy")) {
            const offerName = target
              .closest("button.code-copy")
              .getAttribute("data-entity-name");
            ga4Tracking("PDP", "PDP: Offer Interaction", offerName);
          }

          if (
            target.closest(
              '.note-text a[href="#flits-otp-login-root-container"]',
            )
          ) {
            ga4Tracking(
              "PDP",
              "PDP: Login in Pop-up Interaction",
              "PDP: Login in Pop-up Interaction",
            );
          }

          if (target.closest("img.snap_merchant_logo_add_widget")) {
            ga4Tracking(
              "PDP",
              "PDP: Snapmint View Plans Interaction",
              "PDP: Snapmint View Plans Interaction",
            );
          }

          if (target.closest("button.share_btn")) {
            ga4Tracking(
              "PDP",
              "PDP: Share Icon Interaction",
              "PDP: Share Icon Interaction",
            );
          }

          const pageBtn = target.closest(
            ".jdgm-rev-widg__body .jdgm-paginate__page",
          );

          if (pageBtn) {
            const pageLabel =
              pageBtn.getAttribute("aria-label") ||
              pageBtn.getAttribute("data-page") ||
              pageBtn.textContent.trim() ||
              "pagination";

            ga4Tracking(
              "PDP",
              "PDP: Reviews Pagination Interaction",
              pageLabel,
            );
          }

          if (target.closest("button.gift-card")) {
            const productName = target
              .closest("button.gift-card")
              .querySelector(".gift-card__name")
              .textContent.trim();
            ga4Tracking(
              "PDP",
              "PDP: Make your Gift Extra Special Interaction",
              productName,
            );
          }

          if (target.closest('button[class*="product-collapsible"]')) {
            const accordionName = target
              .closest('button[class*="product-collapsible"]')
              .textContent.trim();
            ga4Tracking("PDP", "Accordion Interaction", accordionName);
          }

          if (
            target.closest(
              "input.gift-option_checkbox, label.gift-option__header",
            )
          ) {
            ga4Tracking(
              "PDP",
              "Gift Checkbox Interaction",
              "Gift Checkbox Interaction",
            );
          }

          const pdpAtcBtn = target.closest(
            'button.add-to-cart.custom-sticky-adtc-btn, button[data-add-to-cart], button[name="add"]',
          );

          if (pdpAtcBtn) {
            let atcLabel = "PDP: Add to Cart Interaction";

            if (
              pdpAtcBtn.classList.contains("custom-sticky-adtc-btn") ||
              pdpAtcBtn.hasAttribute("data-sticky-btn")
            ) {
              atcLabel = "Custom Sticky ATC Button";
            } else {
              atcLabel = "Main Add to Cart Button";
            }

            ga4Tracking("PDP", "PDP: Add to Cart Interaction", atcLabel);
          }

          const pdpWishlist = target.closest(
            '[class*="ProductPageAddToWishList"]',
          );
          if (pdpWishlist) {
            ga4Tracking("PDP", "PDP: Wishlist Interaction", pathname);
          }

          if (target.closest("button#deCheckBtn")) {
            ga4Tracking(
              "PDP",
              "PDP: Delivery CTA Interaction",
              "PDP: Delivery CTA Interaction",
            );
          }

          if (target.closest(".de-options label.de-option:not(.hide")) {
            const deliveryOption = target
              .closest("label.de-option")
              .getAttribute("data-delivery-type");
            ga4Tracking(
              "PDP",
              "PDP: Delivery Options Interaction",
              deliveryOption,
            );
          }

          if (target.closest("a.lbcCard__product")) {
            const productName = target
              .closest("a.lbcCard__product")
              .querySelector(".lbcCard__product-title")
              .textContent.trim();
            ga4Tracking(
              "PDP",
              "PDP: Creators Product Tile Interaction",
              productName,
            );
          }

          if (target.closest('a[class*="write-rev-link"]')) {
            ga4Tracking(
              "PDP",
              "PDP: Write a Review Interaction",
              "PDP: Write a Review Interaction",
            );
          }

          if (target.closest('a[class*="ask-question-btn"]')) {
            ga4Tracking(
              "PDP",
              "PDP: Ask a Question Interaction",
              "PDP: Ask a Question Interaction",
            );
          }

          if (
            target.closest(
              'a[href="https://salty.co.in/policies/shipping-policy"], a[href="https://salty.co.in/policies/refund-policy"]',
            )
          ) {
            ga4Tracking(
              "PDP",
              "PDP: Return & Shipping Policy Interaction",
              "PDP: Return & Shipping Policy Interaction",
            );
          }

          if (target.closest('a[href="/policies/refund-policy"]')) {
            ga4Tracking(
              "PDP",
              "PDP: Refund Policy Interaction",
              "PDP: Refund Policy Interaction",
            );
          }

          if (target.closest('a[href="/policies/shipping-policy"]')) {
            ga4Tracking(
              "PDP",
              "PDP: Shipping Policy Interaction",
              "PDP: Shipping Policy Interaction",
            );
          }

          if (target.closest(".hamper-card:not(.is-active)")) {
            const hamper = target
              .closest(".hamper-card")
              .querySelector(".hamper-content h4")
              .textContent.trim();
            ga4Tracking("PDP", "Gift PDP: Style Interaction", hamper);
          }

          if (target.closest(".compare-hampers__title")) {
            ga4Tracking(
              "PDP",
              "Gift PDP: Compare Hampers Interaction",
              "Gift PDP: Compare Hampers Interaction",
            );
          }
        }

        if (pathname === "/cart") {
          if (target.closest(".cart__item .cart__image")) {
            const productName = target
              .closest(".cart__item")
              .querySelector(".cart__item-title")
              .textContent.trim();
            ga4Tracking("Cart", "Cart: Product Image Interaction", productName);
          }

          const qtyBtn = target.closest(
            ".js-qty__adjust--minus, .js-qty__adjust--plus",
          );

          if (qtyBtn) {
            const actionType = qtyBtn.classList.contains("js-qty__adjust--plus")
              ? "add"
              : "remove";
            ga4Tracking("Cart", "Cart: Quantity Interaction", actionType);
          }

          if (target.closest(".cart__item .cart__item-title")) {
            const productName = target
              .closest(".cart__item-title")
              .textContent.trim();
            ga4Tracking("Cart", "Cart: Product Title Interaction", productName);
          }

          if (target.closest("button#applyDiscountBtn")) {
            ga4Tracking(
              "Cart",
              "Cart: Coupon Apply CTA Click",
              "Cart: Coupon Apply CTA Click",
            );
          }

          if (target.closest("a#view_more_btn")) {
            ga4Tracking(
              "Cart",
              "Cart: view all coupon",
              "Cart: view all coupon",
            );

            setTimeout(() => {
              const offersModal = document.querySelector(
                "#all_offers_container",
              );
              if (
                offersModal &&
                window.getComputedStyle(offersModal).display !== "none"
              ) {
                ga4Tracking(
                  "Cart",
                  "Cart: Discount pop-up Open",
                  "Cart: Discount pop-up Open",
                );
              }
            }, 300);
          }

          if (target.closest("button#offers_close_btn")) {
            ga4Tracking(
              "Cart",
              "Cart: Discount pop-up Close",
              "Cart: Discount pop-up Close",
            );
          }

          if (target.closest("button.cart-summary__code-copy")) {
            ga4Tracking("Cart", "Cart: Copy Coupon", "Cart: Copy Coupon");
          }

          if (target.closest('button[name="checkout"]')) {
            ga4Tracking(
              "Cart",
              "Cart: Checkout CTA Clicks",
              "Cart: Checkout CTA Clicks",
            );
          }

          if (target.closest(".new-product-card")) {
            if (target.closest('[id*="RecentlyViewed"]')) {
              ga4Tracking(
                "Cart",
                "Cart: Recently Viewed Product Interaction",
                "Cart: Recently Viewed Product Interaction",
              );
            } else {
              ga4Tracking(
                "Cart",
                "Cart: people are also buying Product Interaction",
                "Cart: people are also buying Product Interaction",
              );
            }
          }

          if (target.closest(".new-product-card button.add-to-cart")) {
            if (target.closest('[id*="RecentlyViewed"]')) return;
            ga4Tracking(
              "Cart",
              "Cart: people are also buying CTA Click",
              "Cart: people are also buying CTA Click",
            );
          }

          if (target.closest('a[href="/collections/all"]')) {
            const continueShoppingBtn = target.closest(
              'a[href="/collections/all"]',
            );
            if (
              continueShoppingBtn &&
              continueShoppingBtn.textContent.trim().toLowerCase() ===
                "continue shopping"
            ) {
              ga4Tracking(
                "Cart",
                "Cart: Continue Shopping CTA",
                "Cart: Continue Shopping CTA",
              );
            }
          }

          if (target.closest("button#changeLocation")) {
            ga4Tracking(
              "Cart",
              "Cart: Delivery pincode interaction",
              "Cart: Delivery pincode interaction",
            );
          }

          if (target.closest("button#checkPin")) {
            ga4Tracking("Cart", "Cart: check pincode", "Cart: check pincode");
          }

          if (target.closest("button.cart-mobile-checkout__details")) {
            ga4Tracking(
              "Cart",
              "Cart: see details -amount",
              "Cart: see details -amount",
            );
          }

          if (target.closest("button.clear_code_btn")) {
            ga4Tracking(
              "Cart",
              "Cart: Discount code Removed",
              "Cart: Discount code Removed",
            );
          }

          if (
            target.closest(
              'a.cart__banner-btn[data-entity-id="/account/login"]',
            )
          ) {
            ga4Tracking(
              "Cart",
              "Cart: interaction with login",
              "Cart: interaction with login",
            );
          }
        }

        // sitewide goals below
        if (target.closest(".header-item.header-item--logo")) {
          ga4Tracking("Sitewide", "Sitewide : Clicks on Logo", "Logo_ click");
        }

        if (
          target.closest(
            'a[href="#flits-otp-login-root-container"].site-nav__link--icon:not(.wishlist-icon)',
          )
        ) {
          ga4Tracking("Sitewide", "Sitewide : Clicks on Account", pathname);
        }

        if (
          target.closest(
            'a[href="#flits-otp-login-root-container"].site-nav__link--icon.wishlist-icon',
          )
        ) {
          ga4Tracking(
            "Sitewide",
            "Sitewide : Clicks on wishlist icon",
            pathname,
          );
        }

        if (
          target.closest('span.st-mobile-back-arrow[title="close"]') &&
          window.innerWidth < 768
        ) {
          ga4Tracking(
            "Sitewide",
            "Sitewide : Search Closed",
            "Sitewide : Search Closed",
          );
        }

        if (target.closest('a[href="/cart"]')) {
          ga4Tracking("Sitewide", "Sitewide : Clicks on Cart", pathname);
        }

        if (target.closest(".girls-dropdown-wrapper")) {
          ga4Tracking(
            "Sitewide",
            "Sitewide : Clicks on Men/Women dropdown click",
            pathname,
          );
        }

        if (
          target.closest(
            "button.site-nav__link.site-nav__link--icon.js-drawer-open-nav",
          )
        ) {
          ga4Tracking(
            "Sitewide",
            "Sitewide : Clicks on Men/Women dropdown click",
            pathname,
          );
        }

        if (target.closest(".drawer-tabs button:not(.active)")) {
          const tabName = target.closest("button").textContent.trim();
          ga4Tracking(
            "Sitewide",
            "Sitewide : HB : Clicks on Men/Women CTA",
            tabName,
          );
        }

        if (
          target.closest(
            ".drawer-menu.left-menu ul.drawer-subtabs li:not(.active)",
          )
        ) {
          const mainMenuName = target.closest("li").textContent.trim();
          ga4Tracking(
            "Sitewide",
            "Sitewide : Main Menu Item Clicked",
            mainMenuName,
          );
        }

        if (target.closest(".drawer-content .subtab-panel .category-grid a")) {
          const subMenuName = target.closest("a").textContent.trim();
          ga4Tracking(
            "Sitewide",
            "Sitewide : Sub Menu Item Clicked",
            subMenuName,
          );
        }

        if (target.closest(".drawer__fixed-footer a.cs_ft_links")) {
          const buttonName = target.closest("a").textContent.trim();
          ga4Tracking(
            "Sitewide",
            "Sitewide : HB: Clicks on Sticky CTA",
            buttonName,
          );
        }

        if (target.closest(".drawer__title a.wishlist-icon")) {
          ga4Tracking(
            "Sitewide",
            "Sitewide : HB: Wishlist Clicks",
            "Sitewide : HB: Wishlist Clicks",
          );
        }

        if (target.closest('.drawer__title a[href="/cart"]')) {
          ga4Tracking(
            "Sitewide",
            "Sitewide : HB: Cart Clicks",
            "Sitewide : HB: Cart Clicks",
          );
        }

        if (target.closest('footer li[data-entity-type="card"]')) {
          if (!target.closest("a")) return;
          ga4Tracking(
            "Sitewide",
            "Footer : Clicks on link",
            target.closest("a").getAttribute("href"),
          );
        }

        if (target.closest("button#changeLocation")) {
          ga4Tracking("Sitewide", "Delivery ETA_-interaction", "");
        }

        if (target.closest("footer button.footer-accordion__toggle")) {
          const accordionName = target
            .closest("button.footer-accordion__toggle")
            .textContent.trim();
          ga4Tracking(
            "Sitewide",
            "Footer : Accordion Interaction",
            accordionName,
          );
        }

        if (target.closest(".custom-footer__socials a")) {
          const accordionName = target
            .closest(".custom-footer__socials a")
            .getAttribute("data-entity-name");
          ga4Tracking(
            "Sitewide",
            "Footer : Accordion Interaction",
            accordionName,
          );
        }

        if (target.closest(".custom-footer__contact a")) {
          const accordionName = target
            .closest(".custom-footer__contact a")
            .getAttribute("data-entity-name");
          ga4Tracking(
            "Sitewide",
            "Footer: Contact Us Interaction",
            accordionName,
          );
        }
      });

      delegateEvent(document, "click", "body", ({ target }) => {
        const pathname = window.location.pathname;
        if (!/^\/products\/[^/]+/.test(pathname)) return;

        const productLink = target.closest(
          '.helium-custom-recommendations a[href*="/products/"], .helium-rec-slider-root a[href*="/products/"]',
        );
        if (!productLink) return;

        const wrapper = productLink.closest(
          ".helium-custom-recommendations, .helium-rec-slider-root",
        );
        if (!wrapper) return;

        const productCard = productLink.closest(".new-product-card");
        const productItem = productLink.closest(
          '[data-helium-name="product-item"], [data-helium-name="h_product-item"]',
        );

        const sectionTitle =
          wrapper
            .querySelector(".helium-heading")
            ?.textContent?.replace(/\s+/g, " ")
            ?.trim()
            ?.toLowerCase() || "";

        const productName =
          productCard
            ?.querySelector(".new-product-card__title")
            ?.textContent?.replace(/\s+/g, " ")
            ?.trim() ||
          productItem?.getAttribute("data-product-handle") ||
          productItem?.getAttribute("data-helium-product-handle") ||
          "";

        if (!productName) return;

        if (sectionTitle.includes("recommended")) {
          ga4Tracking(
            "PDP",
            "PDP: Recommended Product Tile Interaction",
            productName,
          );
        } else if (sectionTitle.includes("similar")) {
          ga4Tracking(
            "PDP",
            "PDP: Similar Products Tile Interaction",
            productName,
          );
        }
      });

      document.addEventListener(
        "click",
        function (e) {
          const socialLink = e.target.closest("a.smpl-img-link");
          if (!socialLink) return;

          const pathname = window.location.pathname;
          if (!(pathname === "/" || pathname === "/pages/mens-accessories"))
            return;

          const isMenPage = pathname.includes("/mens") ? " Men" : "";

          ga4Tracking(
            "Homepage",
            `Homepage - Social Visits${isMenPage}`,
            socialLink.href,
          );
        },
        true,
      );

      delegateEvent(document, "change", "body", ({ target }) => {
        if (
          pathname.includes("/products/") &&
          !pathname.endsWith("/products/")
        ) {
          if (
            target.matches(
              ".gift-form__control select, .gift-form__control input, .gift-form__control textarea",
            )
          ) {
            ga4Tracking(
              "PDP",
              "Gift Form Interaction",
              "Gift Form Interaction",
            );
            console.log("Gift Form Interaction fired");
          }

          if (target.closest('input[name="quantity"]')) {
            const inputValue = target.closest('input[name="quantity"]').value;
            ga4Tracking("PDP", "PDP: Quantity Interaction", inputValue);
          }

          if (target.closest("input#dePincode, input.de-pincode")) {
            ga4Tracking(
              "PDP",
              "PDP: Delivery Field Interaction",
              "PDP: Delivery Field Interaction",
            );
          }
        }

        if (pathname === "/cart") {
          if (target.closest("input#input_discount_code")) {
            const inputValue = target.closest(
              "input#input_discount_code",
            ).value;
            const inputAction = inputValue === "" ? "Remove" : "Add";
            ga4Tracking("Cart", "Cart: Coupon Field Interaction", inputAction);
          }

          if (target.closest("input#manualPincode")) {
            ga4Tracking(
              "Cart",
              "Cart: enter pincode _delivery",
              "Cart: enter pincode _delivery",
            );
          }
        }

        if (target.closest("input#Search")) {
          ga4Tracking(
            "Sitewide",
            "Sitewide : Interaction with search",
            pathname,
          );
        }
      });

      delegateEvent(document, "click", "body", ({ target }) => {
        if (pathname === "/cart") {
          const removeBtn = target.closest(
            '.cart__remove a[href*="/cart/change"]',
          );
          if (removeBtn) {
            ga4Tracking("Cart", "Cart: delete product", "Cart: delete product");
          }

          const editDeliveryBtn = target.closest(
            "#cartChangePinBtn, .cart-summary__delivery-edit",
          );
          if (editDeliveryBtn) {
            ga4Tracking("Cart", "Cart: edit delivery", "Cart: edit delivery");
          }
        }
      });

      delegateEvent(document, "focus", "body", ({ target }) => {
        if (target.closest("input#manualPincode")) {
          ga4Tracking(
            "Sitewide",
            "Cart: edit delivery ",
            "Cart: edit delivery",
          );
        }
      });

      delegateEvent(document, "blur", "body", ({ target }) => {
        if (target.closest("input#Search") && window.innerWidth >= 768) {
          ga4Tracking(
            "Sitewide",
            "Sitewide : Search Closed ",
            "Sitewide : Search Closed",
          );
        }
      });

      if (pathname === "/cart") {
        waitUntil(
          () => document.querySelector(".best-paired__scroller") !== null,
        ).then(() => {
          const bestPairedContainer = document.querySelector(
            ".best-paired__scroller",
          );
          let hasTracked = false;
          bestPairedContainer.addEventListener("scroll", () => {
            const scrollLeft = bestPairedContainer.scrollLeft;

            if (scrollLeft === 0) hasTracked = false;

            if (!hasTracked && scrollLeft > 1) {
              hasTracked = true;
              ga4Tracking(
                "Cart",
                "Cart: best paired with hortizontal scroll",
                "Cart: best paired with hortizontal scroll",
              );
            }
          });
        });

        waitForElement(".best-paired__scroller").then((bestPairedContainer) => {
          let hasTracked = false;
          bestPairedContainer.addEventListener("scroll", () => {
            const scrollLeft = bestPairedContainer.scrollLeft;

            if (scrollLeft === 0) hasTracked = false;

            if (!hasTracked && scrollLeft > 1) {
              hasTracked = true;
              ga4Tracking(
                "Cart",
                "Cart: best paired with hortizontal scroll",
                "Cart: best paired with hortizontal scroll",
              );
            }
          });
        });
      }

      if (pathname === "/pages/gifting-page") {
        document.addEventListener(
          "click",
          function (e) {
            const bannerContainer = e.target.closest(".banner__overlay");
            if (!bannerContainer) return;

            //alert('banner clicked')
            let name = bannerContainer.dataset.bannerName;
            //alert(name);
            ga4Tracking(
              "GIFT landing page",
              `GIFT- Banner Intereraction`,
              `${name}`,
            );
          },
          true,
        );

        document.addEventListener(
          "click",
          function (e) {
            const bannerContainerOne = e.target.closest(
              ".img_container#img_one",
            );
            if (!bannerContainerOne) return;

            //alert('Sub Banner one clicked')
            let imglink = bannerContainerOne.dataset.imgLink;
            //alert(imglink);
            ga4Tracking(
              "GIFT landing page",
              `Gift - Sub Banner Position Interaction`,
              `${imglink}`,
            );
          },
          true,
        );

        document.addEventListener(
          "click",
          function (e) {
            const bannerContainerTwo = e.target.closest(
              ".img_container#img_two",
            );
            if (!bannerContainerTwo) return;

            //alert('Sub Banner Two clicked')
            let imglink = bannerContainerTwo.dataset.imgLink;
            //alert(imglink);
            ga4Tracking(
              "GIFT landing page",
              `Gift - Sub Banner Position Interaction`,
              `${imglink}`,
            );
          },
          true,
        );

        document.addEventListener(
          "click",
          function (e) {
            const momentCard = e.target.closest(".moment-card");
            if (!momentCard) return;

            let catLink = momentCard.dataset.catLink;
            let categoryName = momentCard.dataset.category;

            //alert('momentCard clicked')
            console.warn("momentCard", momentCard.dataset);

            ga4Tracking(
              "GIFT landing page",
              `GIFT-whats the moment interaction`,
              `${categoryName}`,
            );
          },
          true,
        );

        const momentScroller = document.querySelector(".moment-scroller");
        let hasTracked = false;
        if (momentScroller) {
          momentScroller.addEventListener("scroll", () => {
            const scrollLeft = momentScroller.scrollLeft;

            if (scrollLeft === 0) hasTracked = false;

            if (!hasTracked && scrollLeft > 1) {
              hasTracked = true;
              console.warn("scrollLeft::", scrollLeft);
              ga4Tracking(
                "GIFT landing page",
                "GIFT-whats the moment scroll interaction",
                `${scrollLeft}%`,
              );
            }
            // gf-collection-tabs-grid__tab-btn
          });
        }

        var gatxt = ``;
        var tablabel = ``;
        const colTabGlobal = document.querySelector(
          ".gf-collection-tabs-grid__tab-btn.is-active",
        );
        console.warn("colTabGlobal::", colTabGlobal);
        if (colTabGlobal) {
          gatxt = colTabGlobal.dataset.gaTxt;
          tablabel = colTabGlobal.dataset.tabLabel;
        }
        console.warn("gatxt::", gatxt);
        console.warn("tablabel::", tablabel);
        document.addEventListener("click", function (e) {
          const colTab = e.target.closest(".gf-collection-tabs-grid__tab-btn");
          if (!colTab) return;
          gatxt = colTab.dataset.gaTxt;
          tablabel = colTab.dataset.tabLabel;
          //console.warn(gatxt)
          //alert(tablabel);
          ga4Tracking("GIFT landing page", `Gift-${gatxt}`, `${tablabel}`);
        });

        document.addEventListener("click", function (e) {
          const adtcClick = e.target.closest(
            'button[name="add"][data-product-form-new][data-add-to-cart]',
          );

          //console.warn('adtcClick::',adtcClick);

          const productCard = e.target.closest(".new-product-card");
          //console.warn('productCard::',productCard);
          if (!productCard) return;
          let productName = productCard.querySelector(
            "h3.new-product-card__title",
          ).textContent;
          productName = productName.replace(/\s+/g, " ").trim();
          //console.warn('productName::',productName);

          //Gift-what they'll love interaction-product tile
          if (adtcClick && productName) {
            ga4Tracking(
              "GIFT landing page",
              `Gift-${gatxt} -product tile`,
              `${productName}`,
            );
            ga4Tracking(
              "GIFT landing page",
              `Gift-${gatxt} -add to cart CTA product tile`,
              `${productName}`,
            );
          }
        });
        document.addEventListener("click", function (e) {
          const viewAll = e.target.closest(
            ".gf-collection-tabs-grid__view-all>a",
          ); //innerText

          if (viewAll) {
            console.warn(viewAll);
            let catName = viewAll.dataset.category;
            ga4Tracking(
              "GIFT landing page",
              `Gift-${gatxt} -view all`,
              `${catName}`,
            );
          } else {
            return;
          }
        });
        document.addEventListener("click", function (e) {
          const wishlistBtn = e.target.closest(
            ".flits-collection-page-wishlist-button",
          );
          if (!wishlistBtn) return;

          //console.warn("wishlistBtn::",wishlistBtn);
          let productName = wishlistBtn.dataset.productName;
          ga4Tracking(
            "GIFT landing page",
            `Gift-${gatxt} -product tile`,
            `${productName}`,
          );
          ga4Tracking(
            "GIFT landing page",
            `Gift-${gatxt} -wishlist`,
            `${productName}`,
          );
        }); //new-product-card__rating
        document.addEventListener("click", function (e) {
          //e.preventDefault();
          const reviewBtn = e.target.closest(".new-product-card__rating");
          //console.warn("reviewBtn::",reviewBtn);
          if (!reviewBtn) return;

          let productName = reviewBtn.dataset.productName;
          ga4Tracking(
            "GIFT landing page",
            `Gift-${gatxt} -product tile`,
            `${productName}`,
          );
          ga4Tracking(
            "GIFT landing page",
            `Gift-${gatxt} -reviews`,
            `${productName}`,
          );
        });

        document.addEventListener("click", function (e) {
          const productCard = e.target.closest("a.lbcCard__product");

          if (!productCard) return;
          console.warn(productCard);

          let productName = productCard.dataset.productName;
          let productLink = productCard.dataset.productLink;
          ga4Tracking(
            "GIFT landing page",
            `Gift- video section interaction-product`,
            `${productName}`,
          );
          // ga4Tracking('GIFT landing page', `Gift- video section interaction-product`, `${productLink}`);
        });

        const lbc_scroller = document.querySelector(".lbc__scroller");
        if (lbc_scroller) {
          lbc_scroller.addEventListener("scroll", () => {
            const scrollLeft = lbc_scroller.scrollLeft;
            let hasTrackedgf = false;
            if (scrollLeft === 0) hasTrackedgf = false;

            if (!hasTrackedgf && scrollLeft > 1) {
              hasTrackedgf = true;
              ga4Tracking(
                "GIFT landing page",
                "Gift- video section interaction-scroll",
                `Gift- video section interaction-scroll`,
              );
            }
          });
        }

        const gifted__scroller = document.querySelector(
          ".gf-most-gifted__scroller",
        );
        if (gifted__scroller) {
          gifted__scroller.addEventListener("scroll", () => {
            const scrollLeft = gifted__scroller.scrollLeft;
            let hasTrackedgf = false;
            if (scrollLeft === 0) hasTrackedgf = false;

            if (!hasTrackedgf && scrollLeft > 1) {
              hasTrackedgf = true;
              ga4Tracking(
                "GIFT landing page",
                "GIFT-Most gifted section interaction",
                `GIFT-Most gifted section interaction`,
              );
            }
          });
        }

        // moment section
        const moment_scroller = document.querySelector(".never-miss__scroller");
        if (moment_scroller) {
          moment_scroller.addEventListener("scroll", () => {
            const scrollLeft = moment_scroller.scrollLeft;
            let hasTrackedgf = false;
            if (scrollLeft === 0) hasTrackedgf = false;

            if (!hasTrackedgf && scrollLeft > 1) {
              hasTrackedgf = true;
              ga4Tracking(
                "GIFT landing page",
                "GIFT-moment section interaction",
                ``,
              );
              ga4Tracking(
                "GIFT landing page",
                "GIFT-moment section interaction - scroll",
                `GIFT-moment section interaction - scroll`,
              );
            }
          });
        }

        //gf-most-gifted__card
        document.addEventListener("click", function (e) {
          const productCardGF = e.target.closest(".gf-most-gifted__card");
          if (!productCardGF) return;

          console.warn("productCardGF::", productCardGF);
          let categoryName = productCardGF.dataset.categoryName;
          let categoryLink = productCardGF.dataset.categoryLink;

          ga4Tracking(
            "GIFT landing page",
            "GIFT-Most gifted section interaction -sub sections",
            `${categoryName}`,
          );
          // ga4Tracking('GIFT landing page', 'GIFT-Most gifted section interaction -sub sections', `${categoryLink}`);
        });

        document.addEventListener("click", function (e) {
          const productCardNF = e.target.closest(".never-miss__card");
          if (!productCardNF) return;

          console.warn("productCardNF::", productCardNF);
          let categoryName = productCardNF.dataset.categoryName;
          let categoryLink = productCardNF.dataset.categoryLink;

          ga4Tracking(
            "GIFT landing page",
            "GIFT-moment section interaction",
            ``,
          );
          ga4Tracking(
            "GIFT landing page",
            "GIFT-Most gifted section interaction -sub sections",
            `${categoryName}`,
          );
          // ga4Tracking('GIFT landing page', 'GIFT-Most gifted section interaction -sub sections', `${categoryLink}`);
        });
        //gf-collection-overlay__banner-link
        document.addEventListener("click", function (e) {
          const bannerCard = e.target.closest(
            ".gf-collection-overlay__banner-link",
          );
          if (!bannerCard) return;

          console.warn("bannerCard::", bannerCard);
          let categoryName = bannerCard.dataset.categoryName;
          let categoryLink = bannerCard.dataset.categoryLink;

          ga4Tracking(
            "GIFT landing page",
            `Gift- vibe section interaction- banner`,
            `${categoryName}`,
          );
          // ga4Tracking('GIFT landing page', 'GIFT-Most gifted section interaction -sub sections', `${categoryLink}`);
        });

        document.addEventListener("click", function (e) {
          const productCard = e.target.closest(
            ".gf-collection-overlay__product",
          );
          if (!productCard) return;

          console.warn("productCard::", productCard);
          let productName = productCard.dataset.productName;
          //let categoryLink = productCard.dataset.categoryLink;

          ga4Tracking(
            "GIFT landing page",
            `Gift- vibe section interaction- banner`,
            `${productName}`,
          );
          // ga4Tracking('GIFT landing page', 'GIFT-Most gifted section interaction -sub sections', `${categoryLink}`);
        });
        // gf-collection-overlay__view-all-mobile
        document.addEventListener("click", function (e) {
          const bannerCard = e.target.closest(
            ".gf-collection-overlay__view-all-mobile",
          );
          if (!bannerCard) return;

          let aTag = bannerCard.querySelector("a");
          console.warn("aTag::", aTag.dataset);
          let categoryName = aTag.dataset.categoryName;
          //let categoryLink = bannerCard.dataset.categoryLink;

          ga4Tracking(
            "GIFT landing page",
            `Gift- vibe section interaction- banner`,
            `${categoryName}`,
          );
          // ga4Tracking('GIFT landing page', 'GIFT-Most gifted section interaction -sub sections', `${categoryLink}`);
        });

        // gf-collection-overlay__scroller
        let gfBannerScroller = document.querySelector(
          ".gf-collection-overlay__scroller",
        );
        if (gfBannerScroller) {
          gfBannerScroller.addEventListener("scroll", () => {
            const scrollLeft = gfBannerScroller.scrollLeft;
            let hasTrackedgf = false;
            if (scrollLeft === 0) hasTrackedgf = false;

            if (!hasTrackedgf && scrollLeft > 1) {
              hasTrackedgf = true;
              ga4Tracking(
                "GIFT landing page",
                "GIFT-moment section interaction",
                ``,
              );
              ga4Tracking(
                "GIFT landing page",
                "Gift- vibe section interaction-scroll",
                `Gift- vibe section interaction-scroll`,
              );
            }
          });
        }
      }
    }, 1000);
  })();
}
